<template>
  <div class="reference-form d-flex">
    <v-col cols="7" class="pa-0 pt-3 mb-3 d-flex flex-column">
      <v-textarea
        v-model="title"
        class="subtitle-2 px-4 pt-0 mt-0 mb-5"
        placeholder="Title"
        rows="1"
        auto-grow
        hide-details
        no-resize
        :rules="titleRules"
        :autofocus="shouldFocus('title')"
        @keydown.enter="$event.preventDefault()"
      />
      <v-textarea
        v-model="abstract"
        class="abstract-field text-body-2 font-weight-light px-4 pt-0 mt-0 fill-height"
        placeholder="Abstract"
        filled
        no-resize
        height="100%"
        :autofocus="shouldFocus('abstract')"
      />
    </v-col>
    <v-col class="pa-0 position-relative grey lighten-4">
      <div
        class="reference-detail-fields pt-3 pb-4 pl-5 pr-4 d-flex flex-column"
      >
        <div class="subtitle-2 pb-2 d-flex">Details</div>
        <div class="d-flex flex-column scroll-view flex-grow-1">
          <author-input-field-list
            v-model="authors"
            class="mb-4"
            :autofocus="shouldFocus('authors')"
          />
          <reference-input-field
            v-model="year"
            class="mb-4"
            type="number"
            label="Year"
            placeholder="Year"
            :autofocus="shouldFocus('year')"
          />
          <reference-input-field
            v-model="placePublished"
            class="mb-4"
            label="Place Published"
            placeholder="Place Published"
            :autofocus="shouldFocus('placePublished')"
          />
          <reference-input-field
            v-model="doi"
            class="mb-4"
            label="DOI"
            placeholder="DOI"
            :autofocus="shouldFocus('doi')"
          />
        </div>
        <div class="d-flex flex-row-reverse flex-grow-0">
          <action-button
            color="success"
            :disabled="!formValid"
            @click="$emit('save')"
          >
            <v-icon left class="material-icons-outlined">
              cloud_done
            </v-icon>
            Save
          </action-button>
          <action-button class="mr-4" @click="$emit('cancel')">
            Cancel
          </action-button>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import ReferenceInputField from '@/components/ReferenceForm/ReferenceInputField';
import AuthorInputFieldList from '@/components/ReferenceForm/AuthorInputFieldList';
import { rules } from '@/modules';
import { Reference } from '@/models';

export default {
  name: 'ReferenceForm',
  components: {
    ActionButton,
    ReferenceInputField,
    AuthorInputFieldList,
  },
  props: {
    value: {
      type: Reference,
      required: true,
    },
    focusField: {
      type: String,
      default: null,
    },
  },
  computed: {
    reference: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    title: {
      get: function () {
        return this.reference.publication.title;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.title = value;
        this.$emit('input', reference);
      },
    },
    abstract: {
      get: function () {
        return this.reference.publication.abstract;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.abstract = value;
        this.$emit('input', reference);
      },
    },
    authors: {
      get: function () {
        return this.reference.publication.authors;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.authors = value;
        this.$emit('input', reference);
      },
    },
    year: {
      get: function () {
        return this.reference.publication.year;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.year = value;
        this.$emit('input', reference);
      },
    },
    placePublished: {
      get: function () {
        return this.reference.publication.placePublished;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.placePublished = value;
        this.$emit('input', reference);
      },
    },
    doi: {
      get: function () {
        return this.reference.publication.doi;
      },
      set: function (value) {
        const reference = this.reference;
        reference.publication.doi = value;
        this.$emit('input', reference);
      },
    },
    titleRules() {
      return [rules.whitespaceOrEmpty('Title is required')];
    },
    formValid() {
      return this.titleRules.every(
        (rule) => rule(this.title) === true
      );
    },
  },
  methods: {
    shouldFocus(fieldName) {
      return this.focusField === fieldName;
    },
  },
};
</script>

<style lang="scss">
.reference-form {
  min-height: 550px;
}
.abstract-field .v-input__control {
  height: 100%;
}
.scroll-view {
  overflow: auto;
}
.position-relative {
  position: relative;
}
.reference-detail-fields {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
